import api from './api';
import { Pagination, StoreSellerAdmin, CreateStoreSellerRequest, UpdateStoreSellerRequest, UserByRole, AdminCategory, AdminPriceTable, UpdateCategoryRequest, AdminProduct, AdminProductFilter } from '../models';
import { ProductImage } from '../models/product';

export const adminService = {
  // Products
  getProducts: (filter: AdminProductFilter) =>
    api.get<Pagination<AdminProduct>>('/products', { params: filter }).then((r) => r.data),

  // Users
  getUsersByRole: (roleId: number) =>
    api.get<UserByRole[]>(`/users/by-role/${roleId}`).then((r) => r.data),

  // StoreSellers
  getSellers: (params?: { page?: number; pageSize?: number; search?: string }) =>
    api.get<Pagination<StoreSellerAdmin>>('/store-sellers', { params }).then((r) => r.data),

  createSeller: (data: CreateStoreSellerRequest) =>
    api.post<number>('/store-sellers', data).then((r) => r.data),

  updateSeller: (id: number, data: UpdateStoreSellerRequest) =>
    api.put<void>(`/store-sellers/${id}`, data).then((r) => r.data),

  deleteSeller: (id: number) =>
    api.delete(`/store-sellers/${id}`).then((r) => r.data),

  // ProductImages
  getProductImages: (productId: number) =>
    api.get<ProductImage[]>(`/products/${productId}/images`).then((r) => r.data),

  uploadProductImage: (productId: number, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api
      .post<void>(`/products/${productId}/images`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },

  deleteProductImage: (productId: number, imageId: number) =>
    api.delete(`/products/${productId}/images/${imageId}`).then((r) => r.data),

  setMainProductImage: (productId: number, imageId: number) =>
    api.put<void>(`/products/${productId}/images/${imageId}/main`).then((r) => r.data),

  reorderProductImages: (productId: number, items: { imageId: number; order: number }[]) =>
    api.put<void>(`/products/${productId}/images/reorder`, items).then((r) => r.data),

  // Categories
  getCategories: () =>
    api.get<Pagination<AdminCategory>>('/categories?pageNumber=1&pageSize=1000').then((r) => r.data),

  updateCategory: (id: number, data: UpdateCategoryRequest) =>
    api.put(`/categories/${id}`, data).then((r) => r.data),

  // PriceTables
  getPriceTables: () =>
    api.get<Pagination<AdminPriceTable>>('/price-tables?pageNumber=1&pageSize=100').then((r) => r.data),
};
